app.mediator.registerModule(MODULE_NAME__DUALPANE, function (app) {

    // "Private class" variables
    var helpers = app.helpers.funcs;

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            // Init
            var scope = this;
            this.$rootElem = $('.mod-dual-pane');
            if (!this.$rootElem.length) return;
            this.addDomListeners();
            this.addMediatorListeners();
        },

        //==========================================================xdiv2====
        // DOM listeners
        //===================================================================

        addDomListeners: function () {
            var scope = this;
            app.globalEventRegistry.addListener('resize', helpers.throttler(function () {
                scope.respondToResize();
            }, 100));
        },

        //==========================================================xdiv2====
        // Mediator listeners
        //===================================================================

        addMediatorListeners: function () {
            // None yet
        },

        //==========================================================xdiv2====
        // Module
        //===================================================================

        respondToResize: function () {
            var useDynamic = $('body').hasClass('screenSizeXs');
            var $img = this.$rootElem.find('.pane-featured-image');
            if (useDynamic) {
                var itemWidth = $img.width();
                var desiredHeight = Math.round((itemWidth / 16) * 9);
                $img.css({
                    height: desiredHeight
                });
            } else {
                $img.css({
                    height: 'auto'
                });
            }
        }
    }
});